import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-merchandize-statistics.component.html',
    selector: 'op-product-dashboard-merchandize-statistics'
})
export class ProductDashboardMerchandizeStatisticsComponent implements AfterViewInit {
    public revenueYesterday: number;
    public revenueToday: number
    public cancellationYesterday: number;
    public cancellationToday: number;
    public revenueCancellationYesterday: number;
    public revenueCancellationToday: number;

    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.revenueYesterday = 1500;
            this.revenueToday = 5500;
            this.cancellationYesterday = 1010;
            this.cancellationToday = 506;
            this.revenueCancellationYesterday = 1000;
            this.revenueCancellationToday = 1500;

            this.changeDetection.detectChanges();
        }, 500);
    }
}